
import {
  TASK_TYPES
} from "../../constants/TASK";
// tasks
import vacation_request from './vacation_request';
import common_draft_request from './common_draft_request';
import year_end_draft_request from './year_end_draft_request';
import expense_request from './expense_request';
import evidence_file_request from './evidence_file_request';
import extend_work_request from './extend_work_request';
import holiday_work_request from './holiday_work_request';
import other_work_request from './other_work_request';
import work_history_request from './work_history_request';
import certificate_request from './certificate_request';
import issue_request from './issue_request';
import approval_handover_request from './approval_handover_request';


const tasks = {
  vacation_request,
  common_draft_request,
  year_end_draft_request,
  expense_request,
  evidence_file_request,
  extend_work_request,
  holiday_work_request,
  other_work_request,
  work_history_request,
  certificate_request,
  issue_request,
  approval_handover_request,
};

/*----------------------------------

options = {
    form, // form
    values, // 상동
    setForm, // form 전체를 다시 setting
    setValues, // 상동
    setInForm, // form 의 특정 대상 수정.
    errors, // error 목록
    setErrors, // error setting
    handleOnChange, // 실시간 change
    handleSubmit, // 실행 액션
    resetForm, // 기본 form 으로 reset
    reset, // 상동
    originForm, // 기본 form
    setOriginForm, // 기본 form 세팅
    isSubmit, // submit 실행 한적 있는지?
    isError, // error 가 있는지 없는지
    setIsError,
    validateFields, // validate용 fields
    setValidateFields, // set validate용 fields
}
---------------------------------*/
export const getTaskService = async ({ type, ...props }) => {
  const target = TASK_TYPES.find(task => task.type === type);
  const getTask = tasks[type];
  const task = getTask ? await getTask(props) : {};
  return {
    ...target,
    ...task
  };
};
